import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "箭头_向右c",
  "use": "箭头_向右c-usage",
  "viewBox": "0 0 279.02 7.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 279.02 7.95\" id=\"箭头_向右c\"><defs><style>#箭头_向右c .cls-1{fill:#aac2c9;}</style></defs><g id=\"箭头_向右c_页面-1\"><g id=\"箭头_向右c_威胁防护-任务详情_立即_预定_展开\" data-name=\"威胁防护-任务详情（立即/预定）展开\"><g id=\"箭头_向右c_编组-27\"><g id=\"箭头_向右c_箭头_向右\" data-name=\"箭头 向右\"><polygon id=\"箭头_向右c_路径\" class=\"cls-1\" points=\"275.38 3.38 0 3.38 0 4.56 275.38 4.56 272 7.95 279.02 3.97 272.11 0 275.38 3.38\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol